















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import { ACTIONS_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import ComponentActionItem from '~/components/actions/action-item.vue'
import { IAction } from '~/assets/interfaces/actions'

@Component({
  components: {
    ComponentActionItem,
    ComponentHeaderWithLink,
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentPageIndexActionsContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly items!: IAction[]
  @Prop({ type: String, default: '' }) readonly title!: string

  private ACTIONS_PATH = ACTIONS_PATH
}
